import axios from "axios";

export default {
    state: {
        token: localStorage.getItem('access_token') || null,
        
        modeFolder: false,
        checkItems: false,
        createFolder: false,
        filter: 'all',
        path: '/files',
        items: [],
    },
    mutations: {
        retrieveFiles(state, data) {
            state.items = data
        },
        updateFilter(state, filter) {
            state.filter = filter
        },
        cancelCreateFolderModal(state) {
            state.createFolder= false
        },
        openModalCreateFolder(state) {
            state.createFolder= true

        },
        CHANGE_MODE(state, value) {
            state.modeFolder = value
        },

        updateItem(state, item) {
            const index = state.items.findIndex(i => i.id == item.id)
            state.items.splice(index, 1, {
                'id': item.id,
                'title': item.title,
                'type': item.type,
                'icon': item.icon,
                'checked': item.checked,
            })
            state.checkItems = this.checkItems ? true : false
        },
        createFolder(state, folder) {
            state.items.push({
                id: folder.id,
                title: folder.title,
                type: folder.type,
                icon: folder.icon,
                path: folder.path,
                checked: false,
            })

            state.createFolder = false
            state.idForItem++
            state.createFolder = false
        },
        removeFolder(state, id) {
          const index = state.items.findIndex(item => item.id == id)
          state.items.splice(index, 1)
      },
      updateFolder(state, folder) {
          const index = state.items.findIndex(item => item.id == todo.id)
          state.todos.splice(index, 1, {
             id: folder.id,
             title: folder.title,
             type: folder.type,
             icon: folder.icon,
             checked: folder.checked,
         })
      },
      addFile(state, item) {
         state.items.push({
            id: item.id,
            title: item.title,
            type: item.type,
            icon: item.icon,
            checked: false,
        })
     },
     openFolder(state, im) {
        state.items = im
     },
     changeActivePath(state, path) {
        state.path = path
     },


 },
 actions: {
    openFolder(context,data) {
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + context.state.token

        axios.post('http://localhost/cloud.perpao.com/public/api/open-folder', {
            folder: data.folder,
        })
        .then(response => {

          context.commit('openFolder', response.data)
          context.commit('changeActivePath', data.folder)

        })
    },
     updateFolder(context, data) {
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + context.state.token

        axios.patch(this.state.users.mainDomain+'files/'+data.id, {
            title: data.title,

        })
        .then(response => {
            console.log(response.data)
            context.commit('updateFolder', response.data)
        })
        .catch(error => {
          console.log(error)
      })
    },
    removeFolder(context, id) {
     axios.defaults.headers.common['Authorization'] = 'Bearer ' + context.state.token

     return new Promise((resolve, reject) => {
        axios.delete(this.state.users.mainDomain+'files/' + id)
        .then(response => {

            context.commit('removeFolder', id)
            resolve(response)

        })
        .catch(error => {
            reject(error)
        })
    })


      },
      retrieveFiles(context) {

        axios.get(this.state.users.mainDomain+'files')
        .then(response => {
            context.commit('retrieveFiles', response.data)
        })
       
         axios.post(this.state.users.mainDomain+'open-folder', {
            folder: data.folder,
        })
        .then(response => {
        
          context.commit('openFolder', response.data)
          context.commit('changeActivePath', data.folder)

        })
        .catch(error => {

        })

    },
    addFile(context, data) {
        context.commit('addFile', data)
    },
    createFolder(context, data) {
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + context.state.token

        return new Promise((resolve, reject) => {
            axios.post(this.state.users.mainDomain+'files', {
                title: data.title,
                path: data.path,

            })
            .then(response => {
                context.commit('createFolder', response.data)
                resolve(response)
            })
            .catch(error => {
                reject(error)
            })
        })
    },
    changeMode(context, value) {
        context.commit('CHANGE_MODE', value)
    },
    updateItem(context, item) {
        context.commit('updateItem', item)
    },
    cancelCreateFolderModal(context) {
        context.commit('cancelCreateFolderModal')
    },
    openModalCreateFolder(context) {
        context.commit('openModalCreateFolder')
    },
    updateFilter(context, filter) {
        context.commit('updateFilter', filter)
    },


},
getters: {
    getFiles(state) {

        if (state.filter == 'all') {
            return state.items
        } else if (state.filter == 'folders') {
            return state.items.filter(item => item.type == 'folder')
        } else if (state.filter == 'articles') {
            return state.items.filter(item => item.type == 'article')
        } else if (state.filter == 'products') {
            return state.items.filter(item => item.type == 'product')
        } else if (state.filter == 'txt') {
            return state.items.filter(item => item.type == 'txt')
        } else if (state.filter == 'pdf') {
            return state.items.filter(item => item.type == 'pdf')
        } else if (state.filter == 'images') {
            return state.items.filter(item => item.type == 'jpg' )
        }

        return state.items
    },
    mode(state) {
        return state.modeFolder
    },
    remaining(state) {
        return state.items.filter(item => item.checked).length
    },
    stateCreateFolder(state) {
        return state.createFolder
    },
    getActivePath(state) {
        return state.path
    },
    getTotalItems(state) {
        return state.items.length

    }




}
}



// WEBPACK FOOTER //
// ./src/store/files.js